export enum TokenType {
    API_KEY = 'apikey',
    AUTHORIAZTION = 'Authorization'
}